import { BaseDto } from "./base.dto";
import { StockDto } from "./stock.dto";
import { StockLocationDto } from "./stockLocation.dto";
import { StockUnitDto } from "./stockUnit.dto";
import { StockWastageDto } from "./stockWastage.dto";

export class StockWastageDetailDto extends BaseDto {
    stockWastage: StockWastageDto;
    stockWastageId: number;
    stockUnit?: StockUnitDto;
    stockUnitId: number;
    stock?: StockDto;
    stockId: number;
    stockLocation?: StockLocationDto;
    stockLocationId: number;
    quantity: number;
    outOfStock: boolean;
    caseQty: number;
    unitQty: number;
    splitQty: number;
    totalValue: number;
    totalAMT: number;
    isStockFromRecipe?: boolean;
}
